"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDataApiCheckStatus = exports.PaymentPaidByType = exports.ParentEntityType = exports.PaymentProviders = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    /** The payment is still a draft, can be modified freely and can't be paid yet */
    PaymentStatus["DRAFT"] = "draft";
    /** The payment has been sent to the end user and can be paid, */
    PaymentStatus["SENT"] = "sent";
    /**
     * The payment has been made by the end user and await a status update from the payment provider
     * In this status it cannot be modified
     * */
    PaymentStatus["PENDING"] = "pending";
    /** The payment is marked as overdue, but it behaves exactly as a sent payment does */
    PaymentStatus["OVERDUE"] = "overdue";
    /** The payment has been paid (nothing can be changed in this payment) */
    PaymentStatus["PAID"] = "paid";
    /** The payment has been rejected (nothing can be changed) */
    PaymentStatus["REJECTED"] = "rejected";
    /** The payment has been cancelled and cannot be paid anymore */
    PaymentStatus["CANCELLED"] = "cancelled";
    /** The payment is being refunded */
    PaymentStatus["REFUND_STARTED"] = "refund_started";
    /** Refund failed */
    PaymentStatus["REFUND_REJECTED"] = "refund_rejected";
    /** Refund successful */
    PaymentStatus["REFUNDED"] = "refunded";
    /** Partial refund successful */
    PaymentStatus["PARTIAL_REFUND"] = "partial_refund";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentProviders;
(function (PaymentProviders) {
    PaymentProviders["FENA_OB"] = "fena_ob";
    PaymentProviders["FENA_OB_QR"] = "fena_ob_qr";
    PaymentProviders["FENA_MOBILE"] = "fena_mobile";
    PaymentProviders["FENA_STRIPE"] = "fena_stripe";
    PaymentProviders["FENA_CHECKOUT"] = "fena_checkout";
    PaymentProviders["FENA_CARD_PAYMENTS"] = "fena_card_payments";
    PaymentProviders["FENA_MOBILE_TOUCH_TO_PAY"] = "fena_mobile_touch_to_pay";
    PaymentProviders["CASH"] = "cash";
    PaymentProviders["CARD"] = "card";
    PaymentProviders["OTHER"] = "other";
    PaymentProviders["NONE"] = "none";
})(PaymentProviders = exports.PaymentProviders || (exports.PaymentProviders = {}));
var ParentEntityType;
(function (ParentEntityType) {
    ParentEntityType["ORDER"] = "order";
    ParentEntityType["BILLING_PLAN"] = "billing_plan";
})(ParentEntityType = exports.ParentEntityType || (exports.ParentEntityType = {}));
var PaymentPaidByType;
(function (PaymentPaidByType) {
    PaymentPaidByType["FENA_OB"] = "fena_ob";
    PaymentPaidByType["FENA_STRIPE"] = "fena_stripe";
})(PaymentPaidByType = exports.PaymentPaidByType || (exports.PaymentPaidByType = {}));
var PaymentDataApiCheckStatus;
(function (PaymentDataApiCheckStatus) {
    PaymentDataApiCheckStatus["PENDING_PAYMENT"] = "pending_payment";
    PaymentDataApiCheckStatus["MISSED_PAYMENT"] = "missed_payment";
    PaymentDataApiCheckStatus["PAYMENT_MADE"] = "payment_made";
    PaymentDataApiCheckStatus["PARTIAL_PAYMENT"] = "partial_payment";
    PaymentDataApiCheckStatus["UNABLE_TO_CHECK"] = "unable_to_check";
    PaymentDataApiCheckStatus["PERMANENT_CONNECTION_LOSS"] = "permanent_connection_loss";
    PaymentDataApiCheckStatus["WAITING_FOR_FIRST_CHECK"] = "waiting_for_first_check";
})(PaymentDataApiCheckStatus = exports.PaymentDataApiCheckStatus || (exports.PaymentDataApiCheckStatus = {}));
